import { render } from "./CourseDetail.vue?vue&type=template&id=07ac710f&scoped=true"
import script from "./CourseDetail.vue?vue&type=script&lang=js"
export * from "./CourseDetail.vue?vue&type=script&lang=js"

import "./CourseDetail.vue?vue&type=style&index=0&id=07ac710f&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-07ac710f"

export default script